import { reactive, ref } from 'vue';
import { defineStore } from 'pinia';
import { assignState } from '@/store/index.js';
import { prizeTypeEnum, getWinnersDefaultState, DEFAULT_WINNERS_DISPLAY_COUNT } from '@/constants/winners.js';
import { retrieveWinners } from '@/services/winners.js';

const useWinnersStore = defineStore('winners', () => {
  const winnersListPerType = reactive(getWinnersDefaultState());
  const allWinners = ref([]);
  const lastUpdated = reactive({ date: null });
  const expandedSections = reactive({
    [prizeTypeEnum.GRAND]: false,
    [prizeTypeEnum.MONTHLY]: false,
    [prizeTypeEnum.WEEKLY]: false,
  });

  const dispatchRetrieveWinners = async (userLanguage = 'EN') => {
    try {
      const { data, lastUpdated: updatedDate } = await retrieveWinners(userLanguage);
      // Store all winners
      // assignState(allWinners, data);
      allWinners.value = data;
      lastUpdated.date = updatedDate;

      // Group winners by prize type
      const groupedWinners = getWinnersDefaultState();

      for (let i = 0; i < data.length; i += 1) {
        const winner = data[i];
        const prizeType = winner.prizeDTO?.type;

        if (prizeType === prizeTypeEnum.MONTHLY) {
          groupedWinners[prizeTypeEnum.MONTHLY].push(winner);
        } else if (prizeType === prizeTypeEnum.GRAND) {
          groupedWinners[prizeTypeEnum.GRAND].push(winner);
        } else if (prizeType === prizeTypeEnum.WEEKLY) {
          groupedWinners[prizeTypeEnum.WEEKLY].push(winner);
        }
      }

      assignState(winnersListPerType, groupedWinners);
    } catch (error) {
      return Promise.reject(error);
    }
  };

  const toggleExpansion = (prizeType) => {
    expandedSections[prizeType] = !expandedSections[prizeType];
  };

  const getVisibleWinners = (prizeType) => {
    const winners = winnersListPerType[prizeType];
    if (expandedSections[prizeType]) {
      return winners;
    }
    return winners.slice(0, DEFAULT_WINNERS_DISPLAY_COUNT);
  };

  const hasMoreWinners = (prizeType) => {
    return winnersListPerType[prizeType].length > DEFAULT_WINNERS_DISPLAY_COUNT;
  };

  return {
    winnersListPerType,
    allWinners,
    lastUpdated,
    expandedSections,
    dispatchRetrieveWinners,
    toggleExpansion,
    getVisibleWinners,
    hasMoreWinners,
  };
});

export default useWinnersStore;
